import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

const getUserById = async (userId) => {
  if (!userId) return null

  try {
    const res = await axiosInstance.get(`${API_ROUTES.Users}/${userId}`)
    if (res.data.success) {
      return res.data.items || res.data.user
    }
    return null
  } catch (error) {
    console.error('Error fetching user by id:', error)
    return null
  }
}

export default getUserById
